import { RestErrorResponse } from '../../types/response/RestErrorResponse';
import { createAction } from '../../utils/action';
import ActionTypes from '../actionTypes';
import { ActionsUnion } from '../types';
import { InternalUser } from '../users/types';
import { ContactPerson, Project, ProjectDetails, ProjectDocument, ProjectSettings, SubcontractorAccount } from './types';

export const Actions = {
  getProjects: () => createAction(ActionTypes.GET_PROJECTS),
  getProjectsSuccess: (projects: Project[]) => createAction(ActionTypes.GET_PROJECTS_SUCCESS, projects),
  getProjectsError: (error: RestErrorResponse) => createAction(ActionTypes.GET_PROJECTS_ERROR, error),

  getProjectDetails: () => createAction(ActionTypes.GET_PROJECT_DETAILS),
  getProjectDetailsSuccess: (data: ProjectDetails) => createAction(ActionTypes.GET_PROJECT_DETAILS_SUCCESS, data),
  getProjectDetailsError: (error: RestErrorResponse) => createAction(ActionTypes.GET_PROJECT_DETAILS_ERROR, error),

  getProjectFile: () => createAction(ActionTypes.GET_PROJECT_FILE),
  getProjectFileSuccess: () => createAction(ActionTypes.GET_PROJECT_FILE_SUCCESS),
  getProjectFileError: (error: RestErrorResponse) => createAction(ActionTypes.GET_PROJECT_FILE_ERROR, error),

  setProjects: (projects: Project[]) => createAction(ActionTypes.SET_PROJECTS, projects),

  getProjectSettings: () => createAction(ActionTypes.GET_PROJECT_SETTINGS),
  getProjectSettingsSuccess: (projectSettings: ProjectSettings) => createAction(ActionTypes.GET_PROJECT_SETTINGS_SUCCESS, projectSettings),
  getProjectSettingsError: (error: RestErrorResponse) => createAction(ActionTypes.GET_PROJECT_SETTINGS_ERROR, error),

  saveProjectSettings: () => createAction(ActionTypes.SAVE_PROJECT_SETTINGS),
  saveProjectSettingsSuccess: (projectSettings: ProjectSettings) => createAction(ActionTypes.SAVE_PROJECT_SETTINGS_SUCCESS, projectSettings),
  saveProjectSettingsError: (error: RestErrorResponse) => createAction(ActionTypes.SAVE_PROJECT_SETTINGS_ERROR, error),

  saveProjectDetails: () => createAction(ActionTypes.SAVE_PROJECT_DETAILS),
  saveProjectDetailsSuccess: (projectDetails: ProjectDetails) => createAction(ActionTypes.SAVE_PROJECT_DETAILS_SUCCESS, projectDetails),
  saveProjectDetailsError: (error: RestErrorResponse) => createAction(ActionTypes.SAVE_PROJECT_DETAILS_ERROR, error),

  getInternalUserProjects: () => createAction(ActionTypes.GET_INTERNAL_USER_PROJECTS),
  getInternalUserProjectsSuccess: (data: Project[]) => createAction(ActionTypes.GET_INTERNAL_USER_PROJECTS_SUCCESS, data),
  getInternalUserProjectsError: (error: RestErrorResponse) => createAction(ActionTypes.GET_INTERNAL_USER_PROJECTS_ERROR, error),

  getExternalUserProjects: () => createAction(ActionTypes.GET_EXTERNAL_USER_PROJECTS),
  getExternalUserProjectsSuccess: (data: Project[]) => createAction(ActionTypes.GET_EXTERNAL_USER_PROJECTS_SUCCESS, data),
  getExternalUserProjectsError: (error: RestErrorResponse) => createAction(ActionTypes.GET_EXTERNAL_USER_PROJECTS_ERROR, error),

  changeProjectStatus: () => createAction(ActionTypes.CHANGE_PROJECT_STATUS),
  changeProjectStatusSuccess: () => createAction(ActionTypes.CHANGE_PROJECT_STATUS_SUCCESS),
  changeProjectStatusError: (error: RestErrorResponse) => createAction(ActionTypes.CHANGE_PROJECT_STATUS_ERROR, error),

  getProjectContacts: () => createAction(ActionTypes.GET_PROJECT_CONTACTS),
  getProjectContactsSuccess: (contacts: ContactPerson[]) => createAction(ActionTypes.GET_PROJECT_CONTACTS_SUCCESS, contacts),
  getProjectContactsError: (error: RestErrorResponse) => createAction(ActionTypes.GET_PROJECT_CONTACTS_ERROR, error),

  getInternalUsersByProjectId: () => createAction(ActionTypes.GET_INTERNAL_USERS_BY_PROJECT_ID),
  getInternalUsersByProjectIdSuccess: (users: InternalUser[]) => createAction(ActionTypes.GET_INTERNAL_USERS_BY_PROJECT_ID_SUCCESS, users),
  getInternalUsersByProjectIdError: (error: RestErrorResponse) => createAction(ActionTypes.GET_INTERNAL_USERS_BY_PROJECT_ID_ERROR, error),

  setInternalUserRole: () => createAction(ActionTypes.SET_INTERNAL_USER_ROLE),
  setInternalUserRoleSuccess: () => createAction(ActionTypes.SET_INTERNAL_USER_ROLE_SUCCESS),
  setInternalUserRoleError: (error: RestErrorResponse) => createAction(ActionTypes.SET_INTERNAL_USER_ROLE_ERROR, error),

  removeInternalUserRole: () => createAction(ActionTypes.REMOVE_INTERNAL_USER_ROLE),
  removeInternalUserRoleSuccess: () => createAction(ActionTypes.REMOVE_INTERNAL_USER_ROLE_SUCCESS),
  removeInternalUserRoleError: (error: RestErrorResponse) => createAction(ActionTypes.REMOVE_INTERNAL_USER_ROLE_ERROR, error),

  getProjectDocuments: () => createAction(ActionTypes.GET_PROJECT_DOCUMENTS),
  getProjectDocumentsSuccess: (data: ProjectDocument[]) => createAction(ActionTypes.GET_PROJECT_DOCUMENTS_SUCCESS, data),
  getProjectDocumentsError: (error: RestErrorResponse) => createAction(ActionTypes.GET_PROJECT_DOCUMENTS_ERROR, error),

  setProjectDetails: (data: ProjectDetails | null) => createAction(ActionTypes.SET_PROJECT_DETAILS, data),

  validateSubcontractorAccount: () => createAction(ActionTypes.VALIDATE_SUBCONTRACTOR_ACCOUNT),
  validateSubcontractorAccountSuccess: (data: SubcontractorAccount) => createAction(ActionTypes.VALIDATE_SUBCONTRACTOR_ACCOUNT_SUCCESS, data),
  validateSubcontractorAccountError: (error: RestErrorResponse) => createAction(ActionTypes.VALIDATE_SUBCONTRACTOR_ACCOUNT_ERROR, error),

  addSubcontractorToProject: () => createAction(ActionTypes.ADD_SUBCONTRACTOR_TO_PROJECT),
  addSubcontractorToProjectSuccess: () => createAction(ActionTypes.ADD_SUBCONTRACTOR_TO_PROJECT_SUCCESS),
  addSubcontractorToProjectError: (error: RestErrorResponse) => createAction(ActionTypes.ADD_SUBCONTRACTOR_TO_PROJECT_ERROR, error),

  sendLoginData: () => createAction(ActionTypes.SEND_LOGIN_DATA),
  sendLoginDataSuccess: (projectId: number, subcontractorId: number) =>
    createAction(ActionTypes.SEND_LOGIN_DATA_SUCCES, { projectId, subcontractorId }),
  sendLoginDataError: (error: RestErrorResponse) => createAction(ActionTypes.SEND_LOGIN_DATA_ERROR, error)
};

export type ProjectActions = ActionsUnion<typeof Actions>;
